module.exports = __webpack_public_path__ + "static/media/logoDPC.dcc242d1.svg";